import { FC, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { checkPaymentStatus } from 'services/transfer';
import PaymentSkeleton from 'components/shared/PaymentSkeleton';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { b2b, showPaymentLoader } from 'constants/generic';

const TransferPaymentPage: FC = () => {
  const [paymentUrl, setPaymentUrl] = useState('');
  const [triesCount, setTriesCount] = useState(60);
  const navigate = useNavigate();
  const timeout = useRef<any>();
  const location = useLocation();
  useGetPage('/transfers/book');

  useEffect(() => {
    if (b2b) {
      if (location.pathname !== `/transfer/payment`) {
        return;
      }
    }

    const newData = sessionStorage.getItem('transferPaymentOrder');
    if (newData) {
      const data = JSON.parse(newData);
      check(data.transactionId);
      setPaymentUrl(data.paymentUrl);
    }

    return () => clearTimeout(timeout.current);
  }, [location]); // eslint-disable-line

  const check = async (transactionId: string) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkPaymentStatus(transactionId);

    if (responseCheck?.orderHasBeenPaid) {
      sessionStorage.setItem('transferSuccessOrder', JSON.stringify(responseCheck.bookingModel));
      navigate(`/transfer/success`);
    } else if (responseCheck?.hasErrors) {
      sessionStorage.setItem('errMessage', responseCheck?.errorMessage);
      navigate('/fail');
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(transactionId), 5000);
    }
  };

  return (
    <div
      className="details-wrapper position-relative"
      style={{ justifyContent: 'center', height: 830 }}
    >
      
        <PaymentSkeleton systemProducts="Transfers" showPaymentLoader={showPaymentLoader} />

      {paymentUrl && !paymentUrl.includes('<iframe') && (
        <iframe
          src={paymentUrl}
          title="pay"
          width={470}
          height={577}
          style={{ marginTop: 35, zIndex: 1 }}
        />
      )}

      {paymentUrl && paymentUrl.includes('<iframe') && (
        <div className="book-payment-wr" dangerouslySetInnerHTML={{ __html: paymentUrl }}></div>
      )}
    </div>
  );
};

export default withErrorBoundary(TransferPaymentPage, 'TransferPaymentPage');
